export const enum Breakpoint {
  desktop = 1440,
  laptopL = 1280,
  laptopM = 1024,
  tabletM = 768,
  tabletS = 680,
  mobile = 425,
  xs = 0,
}
